import React, { useState } from 'react';

import Icon from '../../../components/Icons';
import Button from '../../../components/Button';
import Modal from '../../../components/Modal';
import ShortagesList from './ShortagesList';

import * as S from './styles';

function ShortageField({ shortages = [] }) {
    const [showModalShortages, setShowModalShortages] = useState(false);

    if (shortages.length > 2) {
        return (
            <>
                <S.ClickableShortage onClick={setShowModalShortages}>
                    <Icon name="add_circle_outline" size={17} />
                    <span>Ver carências</span>
                </S.ClickableShortage>

                <Modal
                    title="Lista de carências"
                    subtitle={
                        <S.ShortagesModal>
                            <ShortagesList shortages={shortages} />
                        </S.ShortagesModal>
                    }
                    visible={showModalShortages}
                    onCancel={() => setShowModalShortages(false)}
                    footer={null}
                >
                    <Button type="primary" onClick={() => setShowModalShortages(false)}>Voltar</Button>
                </Modal>
            </>
        );
    }

    return <ShortagesList shortages={shortages} />;
}

export default ShortageField;
